import React from 'react';
import { fmt } from '../../../../helper/storeQuotation';

const ItemList = ({ quotation }) => {
  return (
    <div className="table-responsive p-3">
      <table className="table border-0 custom-table comman-table ">
        <thead>
          <tr>
            <th className="small fw-semibold">#</th>
            <th className="small fw-semibold">Item Name</th>
            <th className="small fw-semibold">Size</th>
            <th className="small fw-semibold">Unit</th>
            <th className="small fw-semibold text-center">Qty</th>
            <th className="small fw-semibold">Finalized Party</th>
            <th className="small fw-semibold text-center">Finalized Rate (₹)</th>
            <th className="small fw-semibold text-end">Finalized Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          {quotation.items.map((item, idx) => {
            const fp = quotation.parties.find(p => {
              const pId = typeof p.party_id === 'object' && p.party_id !== null ? p.party_id?._id : p.party_id;
              const fId = typeof item.finalized_party_id === 'object' && item.finalized_party_id !== null ? item.finalized_party_id?._id : item.finalized_party_id;
              return pId && fId && pId === fId;
            });
            return (
              <tr key={item._id}>
                <td className="text-muted small">{idx + 1}</td>
                <td className="fw-medium">{item.item_name}</td>
                <td>{item.size || "—"}</td>
                <td>{item.unit_name}</td>
                <td className="text-center fw-bold">{fmt(item.quantity)}</td>
                <td>
                  {fp ? (
                    <span className="text-success fw-semibold" style={{ fontSize: '13px' }}>
                      {fp.party_snapshot?.name}
                    </span>
                  ) : (
                    <span className="text-muted small" style={{ fontStyle: 'italic', fontSize: '12px' }}>Not Finalized</span>
                  )}
                </td>
                <td className="text-center small">{item.finalized_rate ? fmt(item.finalized_rate) : "-"}</td>
                <td className="text-end fw-bold text-success small">{fmt(item.finalized_amount)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ItemList;
